let scrollPosition;
const BODY_FIX_CLASS_NAME = 'body-modal-fix';
const MODAL_OPEN_CLASS_NAME = 'modal-is-open';
const MODAL_CLOSE_CLASS_NAME = 'js-modalModule-is-close';

export const modalOpen = target => {
    const modal = document.getElementById(target);
    scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    console.log(scrollPosition);
    let bodyElement = document.querySelector('html body');
    bodyElement.classList.add(BODY_FIX_CLASS_NAME);
    bodyElement.style.top = `-${scrollPosition}px`;
    console.log(bodyElement.style.top);
    modal.classList.add(MODAL_OPEN_CLASS_NAME);
    addCloseEvent(modal);
}

const addCloseEvent = target => {
    let closeButton = target.querySelector(`.${MODAL_CLOSE_CLASS_NAME}`);
    closeButton.addEventListener('click', modalClose);
}
const modalClose = event => {
    let bodyElement = document.querySelector('html body');
    bodyElement.classList.remove(BODY_FIX_CLASS_NAME);
    bodyElement.style.top = '0px';
    window.scrollTo( 0 , scrollPosition );
    let targetElement = event.currentTarget.closest(`.${MODAL_OPEN_CLASS_NAME}`);
    targetElement.classList.remove(MODAL_OPEN_CLASS_NAME);
}